import { memo } from 'react';

/** 柱高 %：宽卡时条变宽、间隙均分，比例不变形（避免 SVG none 拉伸走样） */
const BAR_HEIGHTS = [52, 70, 48, 78, 58, 84, 46, 66, 54, 76, 50, 72];

const LINE =
	'M 4,58 C 12,52 16,34 24,30 C 32,26 38,44 46,48 C 54,52 60,22 68,18 C 76,14 82,36 90,40 C 96,44 100,22 104,18';

/** 折线关键点（相对 viewBox 108×90），用绝对定位圆点避免 stretch 成椭圆 */
const DOTS = [
	{ left: '3.7%', top: '64.4%' },
	{ left: '22.2%', top: '33.3%' },
	{ left: '42.6%', top: '53.3%' },
	{ left: '63%', top: '20%' },
	{ left: '83.3%', top: '44.4%' },
	{ left: '96.3%', top: '20%' },
];

/**
 * 首页经营图加载缩略图：弹性柱 + 折线叠加。
 * 随列宽变宽/收窄只改变柱宽与间距，不整体压扁图形。
 */
const HomeDashboardChartLoadingThumb = () => (
	<div className='dashboard-home-chart-loading__thumb-plot'>
		<div className='dashboard-home-chart-loading__bars' aria-hidden='true'>
			{BAR_HEIGHTS.map((height, index) => (
				<span key={index} className='dashboard-home-chart-loading__bar' style={{ height: `${height}%` }} />
			))}
		</div>
		<svg
			className='dashboard-home-chart-loading__thumb-line-svg'
			viewBox='0 0 108 90'
			preserveAspectRatio='none'
			fill='none'
			aria-hidden='true'
		>
			<line className='dashboard-home-chart-loading__thumb-grid' x1={2} y1={18} x2={106} y2={18} />
			<line className='dashboard-home-chart-loading__thumb-grid' x1={2} y1={44} x2={106} y2={44} />
			<line className='dashboard-home-chart-loading__thumb-grid' x1={2} y1={68} x2={106} y2={68} />
			<line className='dashboard-home-chart-loading__thumb-axis' x1={2} y1={82} x2={106} y2={82} />
			<path className='dashboard-home-chart-loading__thumb-line' d={LINE} />
		</svg>
		{DOTS.map((dot, index) => (
			<span key={index} className='dashboard-home-chart-loading__thumb-dot' style={dot} aria-hidden='true' />
		))}
	</div>
);

export default memo(HomeDashboardChartLoadingThumb);
